import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDialogModule } from '@snelstart/ui-dialog';
import { SharedUiListModule } from "@snelstart/ui-list";
import { SharedUiLoadingModule } from "@snelstart/ui-loading";
import { SharedUiOffCanvasModule } from "@snelstart/ui-off-canvas";
import { FeatureTaxMumaDetailsComponent } from "./tax-muma-details/feature-tax-muma-details.component";
import {MumaComponent} from "./muma/muma.component";


@NgModule({
  imports: [
    CommonModule,
    SharedUiDetailsModule,
    SharedUiFormControlsModule,
    SharedUiButtonModule,
    SharedUiDialogModule,
    SharedUiListModule,
    SharedUiLoadingModule,
    SharedUiOffCanvasModule,
    MumaComponent,
    FeatureTaxMumaDetailsComponent
  ],
  declarations: [

  ],
  exports: [FeatureTaxMumaDetailsComponent],
})
export class FeatureTaxMumaDetailsModule {}
